(function () {
  var editor = window.upcartSettings && window.upcartSettings.upcartEditorSettings;
  if (!editor || !Array.isArray(editor.rewardsTriggeredRules)) return;
  editor.rewardsTriggeredRules = editor.rewardsTriggeredRules.filter(function (rule) {
    return rule.discountId !== 'b69dbf10-9b0c-4577-8f78-6b06243d7aed' &&
      rule.discountId !== '8fdd07cd-7653-4683-a78a-d44899392fae';
  });

  if (!editor.rewardsTriggeredRules.some(function (rule) {
    return rule.discountId === 'afa3775f-ee59-468f-b2b1-1e4ebf50646f';
  })) return;

  var previousSubscriptionProperties = window.upcartAddSubscriptionProperties;
  window.upcartAddSubscriptionProperties = function (item) {
    var properties = typeof previousSubscriptionProperties === 'function'
      ? previousSubscriptionProperties.apply(this, arguments)
      : {};
    return Object.assign({}, properties, {
      '_jci_welcome_gift_flow': '165077025004',
      '_jci_welcome_gift_165077025004': 'true'
    });
  };
})();
